(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p2p-card-search"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-p2p-card-search]');
    if (!root) return;

    var gameClause = root.getAttribute('data-p2p-game-clause') || '';
    var searchInput = root.querySelector('[data-p2p-cs-search]');
    var debounceTimer;

    function buildSearchUrl(term) {
      var url = new URL(window.location.href);
      url.searchParams.set('view', 'card-search');
      url.searchParams.set('type', 'product');
      var q = '';
      if (term && gameClause) {
        q = term + ' AND ' + gameClause;
      } else if (term) {
        q = term;
      } else if (gameClause) {
        q = gameClause;
      }
      if (q) { url.searchParams.set('q', q); } else { url.searchParams.delete('q'); }
      url.searchParams.delete('page');
      return url;
    }

    if (searchInput) {
      searchInput.addEventListener('input', function (e) {
        clearTimeout(debounceTimer);
        var term = e.target.value.trim();
        debounceTimer = setTimeout(function () {
          window.location.href = buildSearchUrl(term).toString();
        }, 550);
      });
    }

    // Quick filters — standard Shopify filter params, toggled client-side.
    var current = new URL(window.location.href);
    root.querySelectorAll('[data-p2p-quick]').forEach(function (btn) {
      var kind = btn.getAttribute('data-p2p-quick');
      var isActive = false;
      if (kind === 'instock') {
        isActive = current.searchParams.get('filter.v.availability') === '1';
      } else if (kind === 'under5') {
        isActive = current.searchParams.get('filter.v.price.lte') === '5' && !current.searchParams.get('filter.v.price.gte');
      }
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      if (isActive) btn.classList.add('p2p-cs-quick--active');

      btn.addEventListener('click', function () {
        var target = new URL(window.location.href);
        if (kind === 'instock') {
          if (target.searchParams.get('filter.v.availability') === '1') {
            target.searchParams.delete('filter.v.availability');
          } else {
            target.searchParams.set('filter.v.availability', '1');
          }
        } else if (kind === 'under5') {
          if (target.searchParams.get('filter.v.price.lte') === '5') {
            target.searchParams.delete('filter.v.price.lte');
          } else {
            target.searchParams.set('filter.v.price.lte', '5');
            target.searchParams.delete('filter.v.price.gte');
          }
        }
        target.searchParams.delete('page');
        window.location.href = target.toString();
      });
    });

    // Price range slider — two overlapping native range inputs sharing
    // one track. Same standard filter.v.price.gte/.lte params as the
    // "Under £5" quick filter above, so the two stay consistent.
    var priceGte = current.searchParams.get('filter.v.price.gte');
    var priceLte = current.searchParams.get('filter.v.price.lte');

    root.querySelectorAll('[data-p2p-price-slider]').forEach(function (sliderEl) {
      var group = sliderEl.closest('.p2p-cs-filter-group');
      var minInput = sliderEl.querySelector('[data-p2p-slider-min]');
      var maxInput = sliderEl.querySelector('[data-p2p-slider-max]');
      var rangeEl = sliderEl.querySelector('[data-p2p-slider-range]');
      var minLabel = group.querySelector('[data-p2p-slider-min-label]');
      var maxLabel = group.querySelector('[data-p2p-slider-max-label]');
      var applyBtn = group.querySelector('[data-p2p-price-apply]');
      var badge = group.querySelector('[data-p2p-price-badge]');

      var sliderMin = parseFloat(sliderEl.getAttribute('data-min'));
      var sliderMax = parseFloat(sliderEl.getAttribute('data-max'));

      // Initialize from current URL state, clamped to the slider's range.
      minInput.value = priceGte ? Math.max(sliderMin, Math.min(sliderMax, parseFloat(priceGte))) : sliderMin;
      maxInput.value = priceLte ? Math.max(sliderMin, Math.min(sliderMax, parseFloat(priceLte))) : sliderMax;

      function formatPrice(v) {
        var num = parseFloat(v);
        return num % 1 === 0 ? ('£' + num) : ('£' + num.toFixed(2));
      }

      function render() {
        var minVal = parseFloat(minInput.value);
        var maxVal = parseFloat(maxInput.value);
        var pct = function (v) { return ((v - sliderMin) / (sliderMax - sliderMin)) * 100; };
        rangeEl.style.left = pct(minVal) + '%';
        rangeEl.style.right = (100 - pct(maxVal)) + '%';
        minLabel.textContent = formatPrice(minVal);
        maxLabel.textContent = formatPrice(maxVal);
      }
      render();

      minInput.addEventListener('input', function () {
        if (parseFloat(minInput.value) > parseFloat(maxInput.value)) { minInput.value = maxInput.value; }
        render();
      });
      maxInput.addEventListener('input', function () {
        if (parseFloat(maxInput.value) < parseFloat(minInput.value)) { maxInput.value = minInput.value; }
        render();
      });

      if (badge) {
        if (priceGte || priceLte) { badge.hidden = false; badge.textContent = '1'; }
        else { badge.hidden = true; }
      }

      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          var target = new URL(window.location.href);
          var minVal = parseFloat(minInput.value);
          var maxVal = parseFloat(maxInput.value);
          if (minVal > sliderMin) { target.searchParams.set('filter.v.price.gte', minVal); } else { target.searchParams.delete('filter.v.price.gte'); }
          if (maxVal < sliderMax) { target.searchParams.set('filter.v.price.lte', maxVal); } else { target.searchParams.delete('filter.v.price.lte'); }
          target.searchParams.delete('page');
          window.location.href = target.toString();
        });
      }
    });

    // Price chip — rendered once (not per filter-group instance) so it
    // doesn't duplicate between the desktop bar and mobile drawer copies.
    if (priceGte || priceLte) {
      var chipsEl = root.querySelector('[data-p2p-chips]');
      if (chipsEl) {
        var priceLabel = priceGte && priceLte ? ('£' + priceGte + ' – £' + priceLte)
          : priceGte ? ('£' + priceGte + '+')
          : ('Under £' + priceLte);
        var chip = document.createElement('span');
        chip.className = 'p2p-cs-chip';
        chip.textContent = priceLabel + ' ';
        var removeLink = document.createElement('a');
        removeLink.className = 'p2p-cs-chip-remove';
        removeLink.setAttribute('aria-label', 'Remove price filter');
        removeLink.textContent = '✕';
        var removeUrl = new URL(window.location.href);
        removeUrl.searchParams.delete('filter.v.price.gte');
        removeUrl.searchParams.delete('filter.v.price.lte');
        removeUrl.searchParams.delete('page');
        removeLink.href = removeUrl.toString();
        chip.appendChild(removeLink);
        var clearAllChip = chipsEl.querySelector('.p2p-cs-chip-clear');
        if (clearAllChip) { chipsEl.insertBefore(chip, clearAllChip); } else { chipsEl.appendChild(chip); }
        chipsEl.hidden = false;
      }
    }

    // Sort — Price Low→High / Price High→Low / Newest / Oldest only.
    var sortLabels = {
      'price-ascending': 'Price: Low to High',
      'price-descending': 'Price: High to Low'
    };
    var activeSort = current.searchParams.get('sort_by');
    root.querySelectorAll('[data-p2p-sort-label]').forEach(function (label) {
      label.textContent = sortLabels[activeSort] || 'Sort';
    });
    root.querySelectorAll('[data-p2p-sort-val]').forEach(function (btn) {
      var val = btn.getAttribute('data-p2p-sort-val');
      var isActive = activeSort === val;
      btn.classList.toggle('p2p-cs-filter-val--active', isActive);
      btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
      btn.addEventListener('click', function () {
        var target = new URL(window.location.href);
        var details = btn.closest('details');
        if (details) details.removeAttribute('open');
        target.searchParams.set('sort_by', val);
        target.searchParams.delete('page');
        window.location.href = target.toString();
      });
    });

    // Click-outside to close open filter dropdowns (Price, Sort, Rarity,
    // etc.) — native <details> only closes on a second click of its own
    // <summary>, so this is purely additive on top of that.
    document.addEventListener('click', function (e) {
      root.querySelectorAll('.p2p-cs-filter-group[open]').forEach(function (group) {
        if (!group.contains(e.target)) {
          group.removeAttribute('open');
        }
      });
    });

    // Mobile drawer (bottom sheet)
    var trigger = root.querySelector('[data-p2p-drawer-trigger]');
    var drawer = root.querySelector('[data-p2p-drawer]');
    var backdrop = root.querySelector('[data-p2p-drawer-backdrop]');
    var closeBtn = root.querySelector('[data-p2p-drawer-close]');
    var applyBtn = root.querySelector('[data-p2p-drawer-apply]');

    function openDrawer() {
      if (!drawer) return;
      drawer.removeAttribute('hidden');
      requestAnimationFrame(function () {
        drawer.classList.add('p2p-cs-drawer--open');
        if (backdrop) backdrop.classList.add('p2p-cs-drawer-backdrop--open');
      });
      document.body.style.overflow = 'hidden';
      var firstFocusable = drawer.querySelector('a, button, input');
      if (firstFocusable) firstFocusable.focus();
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('p2p-cs-drawer--open');
      if (backdrop) backdrop.classList.remove('p2p-cs-drawer-backdrop--open');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.setAttribute('hidden', ''); }, 300);
      if (trigger) trigger.focus();
    }
    if (trigger) trigger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    if (applyBtn) applyBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('p2p-cs-drawer--open')) {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p2p-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.p2p-faq');
    if (!root) return;

    var searchInput = root.querySelector('#p2p-faq-search');
    var emptyState  = root.querySelector('#p2p-faq-empty');
    var allItems    = root.querySelectorAll('.p2p-faq-item');
    var allSections = root.querySelectorAll('.p2p-faq-cat-section');
    var sidebarLinks = root.querySelectorAll('.p2p-faq-sidebar a');

    // Accordion toggle (click or keyboard via native <button>).
    root.querySelectorAll('.p2p-faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.p2p-faq-item');
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Live search — filter items by the live question text + answer
    // text (no separate hand-authored slug to keep in sync anymore).
    if (searchInput) {
      searchInput.addEventListener('input', function (e) {
        var term = e.target.value.toLowerCase().trim();
        var visibleCount = 0;

        allItems.forEach(function (item) {
          var qEl = item.querySelector('.p2p-faq-q-text');
          var q = qEl ? (qEl.textContent || '').toLowerCase() : '';
          var aEl = item.querySelector('.p2p-faq-a-inner');
          var a = aEl ? (aEl.textContent || '').toLowerCase() : '';
          var matches = term === '' || q.indexOf(term) !== -1 || a.indexOf(term) !== -1;
          item.classList.toggle('is-hidden', !matches);
          if (matches) {
            visibleCount++;
            // Auto-expand matched items while searching so the user sees the answer.
            if (term !== '') {
              item.classList.add('is-open');
              var btn = item.querySelector('.p2p-faq-q');
              if (btn) btn.setAttribute('aria-expanded', 'true');
            }
          }
        });

        allSections.forEach(function (section) {
          var anyVisible = section.querySelectorAll('.p2p-faq-item:not(.is-hidden)').length > 0;
          section.style.display = anyVisible ? '' : 'none';
        });

        var show = visibleCount === 0 && term !== '';
        if (emptyState) {
          emptyState.classList.toggle('is-shown', show);
          if (show) emptyState.removeAttribute('hidden');
          else emptyState.setAttribute('hidden', '');
        }
      });
    }

    // Sidebar scroll-spy.
    function setActiveLink(cat) {
      sidebarLinks.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('href') === '#cat-' + cat);
      });
    }
    function updateActiveSection() {
      var scrollPos = window.scrollY + 150;
      var current = null;
      allSections.forEach(function (section) {
        if (section.style.display === 'none') return;
        var top = section.offsetTop;
        var bottom = top + section.offsetHeight;
        if (scrollPos >= top && scrollPos < bottom) current = section.dataset.cat;
      });
      if (current) setActiveLink(current);
    }
    window.addEventListener('scroll', updateActiveSection, { passive: true });
    updateActiveSection();
  })();

  } catch(e) { console.error(e); }
})();
})();
